import request from '@/util/axios';

export const getList = (page, limit, params) => {
  return request({
    url: '/rentbed/sys/sysUser/list',
    method: 'post',
    data: {
      ...params,
      page,
      limit
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/rentbed/sys/sysUser/delete',
    method: 'post',
    data: request.adornData(ids, false)
  })
}

export const save = (row) => {
  return request({
    url: '/rentbed/sys/sysUser/save',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/rentbed/sys/sysUser/update',
    method: 'post',
    data: row
  })
}

export const view = (id) => {
  return request({
    url: '/rentbed/sys/sysUser/view/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/sys/sysUser.js